const activityArr = {
  zh: [
    {
      id: '投融资&BD', label: '投融资&BD',
      children: [
        { id: '中国医疗创新投资者大会', label: '中国医疗创新投资者大会' },
        { id: '医疗器械创新投资与并购论坛', label: '医疗器械创新投资与并购论坛' },
        { id: '医疗器械创新项目及科研成果转化路演', label: '医疗器械创新项目及科研成果转化路演' },
        { id: '中国医药创新投资者大会', label: '中国医药创新投资者大会' },
        { id: '医药创新投资与并购论坛', label: '医药创新投资与并购论坛' },
        { id: '医药创新项目及科研成果转化路演', label: '医药创新项目及科研成果转化路演' },
      ]
    },
    {
      id: '医疗产业', label: '医疗产业',
      children: [
        { id: '中国医疗热门赛道技术创新与产业发展论坛', label: '中国医疗热门赛道技术创新与产业发展论坛' },
        { id: '体外诊断技术与产业发展大会', label: '体外诊断技术与产业发展大会' },
        { id: '内窥镜技术创新发展大会', label: '内窥镜技术创新发展大会' },
        { id: '手术治疗设备创新大会', label: '手术治疗设备创新大会' },
        { id: '能量源医美设备创新大会', label: '能量源医美设备创新大会' },
        { id: '未来医疗辅听创新大会', label: '未来医疗辅听创新大会' },
        { id: '有源医疗器械研发、发展与应用大会', label: '有源医疗器械研发、发展与应用大会' },
        { id: '核医学与分子影像创新与应用大会', label: '核医学与分子影像创新与应用大会' },
        { id: '辅助生殖技术创新发展大会', label: '辅助生殖技术创新发展大会' },
      ]
    },
    {
      id: '医药产业', label: '医药产业',
      children: [
        { id: '中国医药热门赛道技术创新与产业发展论坛', label: '中国医药热门赛道技术创新与产业发展论坛' },
        { id: '创新药及改良新药高峰论坛', label: '创新药及改良新药高峰论坛' },
        { id: 'CGT产业升级大会', label: 'CGT产业升级大会' },
        { id: '多肽药物发展论坛', label: '多肽药物发展论坛' },
        { id: '核酸药物发展论坛', label: '核酸药物发展论坛' },
        { id: '核素药发展论坛', label: '核素药发展论坛' },
        { id: 'RNA疗法论坛', label: 'RNA疗法论坛' },
        { id: '生物安全检测论坛', label: '生物安全检测论坛' },
        { id: '吸入制剂创新论坛', label: '吸入制剂创新论坛' },
        { id: '透皮技术创新论坛（医药+医疗+医美&化妆品）', label: '透皮技术创新论坛（医药+医疗+医美&化妆品）' },
        { id: '宠物药及宠物疫苗论坛', label: '宠物药及宠物疫苗论坛' },
      ]
    },
    {
      id: '生命科学仪器', label: '生命科学仪器',
      children: [
        { id: '生命科学仪器、试剂&耗材国产替代发展论坛', label: '生命科学仪器、试剂&耗材国产替代发展论坛' },
        { id: '高端实验室仪器的现状发展与未来突破论坛', label: '高端实验室仪器的现状发展与未来突破论坛' },
        { id: '生命科学仪器、试剂&耗材企业VC面对面', label: '生命科学仪器、试剂&耗材企业VC面对面' },
        { id: '生命科学仪器、试剂&耗材企业新品发布会', label: '生命科学仪器、试剂&耗材企业新品发布会' },
      ]
    },
    {
      id: '经销采购', label: '经销采购',
      children: [
        { id: '医疗器械与药品经销商模式创新大会', label: '医疗器械与药品经销商模式创新大会' },
        { id: '民营医院采购大会', label: '民营医院采购大会' },
      ]
    },
    {
      id: '出海&海外BD', label: '出海&海外BD',
      children: [
        { id: '中国创新医药医疗企业出海论坛', label: '中国创新医药医疗企业出海论坛' },
        { id: '医疗影像设备创新出海大会', label: '医疗影像设备创新出海大会' },
        { id: '体外诊断创新出海大会', label: '体外诊断创新出海大会' },
        { id: '高值医疗耗材创新出海大会', label: '高值医疗耗材创新出海大会' },
        { id: '医美设备创新出海大会', label: '医美设备创新出海大会' },
        { id: '医药领域（抗体药物、疫苗、创新大分子生物药、CGT、动物试验等出海大会', label: '医药领域（抗体药物、疫苗、创新大分子生物药、CGT、动物试验等出海大会' },
        { id: '中国创新医药医疗企业与MNC公司BD对接会', label: '中国创新医药医疗企业与MNC公司BD对接会' },
      ]
    },
    {
      id: '生物制造产业', label: '生物制造产业',
      children: [
        {
          id: '生物制造产业创新合作论坛', label: '生物制造产业创新合作论坛',
          children: [
            { id: '农业与食品专场', label: '农业与食品专场' },
            { id: '医药与美妆专场', label: '医药与美妆专场' },
            { id: '医用及医美材料专场', label: '医用及医美材料专场' },
          ]
        },
        { id: '高通量筛选与实验室自动化大会', label: '高通量筛选与实验室自动化大会' },
      ]
    },
    {
      id: '数字医疗', label: '数字医疗',
      children: [
        { id: '药企数字化营销论坛', label: '药企数字化营销论坛' },
        { id: '医院智慧管理论坛', label: '医院智慧管理论坛' },
        { id: '连锁诊所数智化论坛', label: '连锁诊所数智化论坛' },
      ]
    },
    {
      id: '健康生活', label: '健康生活',
      children: [
        { id: '退休生活方式创新论坛', label: '退休生活方式创新论坛' },
        { id: '减肥市场创新发展论坛', label: '减肥市场创新发展论坛' },
        { id: '抗衰创新论坛', label: '抗衰创新论坛' },
      ]
    },
    { id: '未来医药医疗100强榜单', label: '未来医药医疗100强榜单' },
    { id: '创新产品力全球首发发布', label: '创新产品力全球首发发布' },
    { id: '医药医疗行业掼蛋大赛及社交活动', label: '医药医疗行业掼蛋大赛及社交活动' },
    { id: 'VB100颁奖盛典暨大会交流晚宴', label: 'VB100颁奖盛典暨大会交流晚宴' },
  ],
  en: [
    {
      id: '投融资&BD', label: 'Investment & Financing &BD',
      children: [
        { id: '中国医疗创新投资者大会', label: 'China Medical Innovation Investor Conference' },
        { id: '医疗器械创新投资与并购论坛', label: 'Medical Device Innovation Investment and M&A Forum' },
        { id: '医疗器械创新项目及科研成果转化路演', label: 'Medical device Innovation Projects and scientific research achievements transformation Roadshow' },
        { id: '中国医药创新投资者大会', label: 'China Pharmaceutical Innovation Investor Conference' },
        { id: '医药创新投资与并购论坛', label: 'Pharmaceutical Innovation Investment and M&A Forum' },
        { id: '医药创新项目及科研成果转化路演', label: 'Pharmaceutical Innovation Projects and research achievements transformation Roadshow' },
      ]
    },
    {
      id: '医疗产业', label: 'Medical Industry',
      children: [
        { id: '中国医疗热门赛道技术创新与产业发展论坛', label: 'China Medical Hot Track Technology Innovation and Industrial Development Forum' },
        { id: '体外诊断技术与产业发展大会', label: 'In Vitro Diagnostic Technology and Industry Development Conference' },
        { id: '内窥镜技术创新发展大会', label: 'Endoscopic Technology Innovation and Development Conference' },
        { id: '手术治疗设备创新大会', label: 'Surgical Treatment Equipment Innovation Conference' },
        { id: '能量源医美设备创新大会', label: 'Energy Source Medical Beauty Equipment Innovation Conference' },
        { id: '未来医疗辅听创新大会', label: 'Future Medical auxiliary Listening Innovation Conference' },
        { id: '有源医疗器械研发、发展与应用大会', label: 'Active Medical Device R&D, Development and Application Conference' },
        { id: '核医学与分子影像创新与应用大会', label: 'Nuclear Medicine and Molecular Imaging Innovation and Application Conference' },
        { id: '辅助生殖技术创新发展大会', label: 'Assisted Reproductive Technology Innovation and Development Conference' },
      ]
    },
    {
      id: '医药产业', label: 'Pharmaceutical Industry',
      children: [
        { id: '中国医药热门赛道技术创新与产业发展论坛', label: 'China Pharmaceutical Hot Track Technology Innovation and Industrial Development Forum' },
        { id: '创新药及改良新药高峰论坛', label: 'Innovative Drugs and Improved New Drugs Summit Forum' },
        { id: 'CGT产业升级大会', label: 'CGT Industrial Upgrading Conference' },
        { id: '多肽药物发展论坛', label: 'Peptide Drug Development Forum' },
        { id: '核酸药物发展论坛', label: 'Nucleic acid Drug Development Forum' },
        { id: '核素药发展论坛', label: 'Nuclide Drug Development Forum' },
        { id: 'RNA疗法论坛', label: 'RNA Therapy Forum' },
        { id: '生物安全检测论坛', label: 'Biosafety Testing Forums' },
        { id: '吸入制剂创新论坛', label: 'Inhalation Formulation Innovation Forum' },
        { id: '透皮技术创新论坛（医药+医疗+医美&化妆品）', label: 'Transdermal Technology Innovation Forum (Pharmaceutical + Medical + Medical Beauty & Cosmetics) ' },
        { id: '宠物药及宠物疫苗论坛', label: 'Pet Medicine and Pet Vaccine Forum' },
      ]
    },
    {
      id: '生命科学仪器', label: 'Life Science Instruments',
      children: [
        { id: '生命科学仪器、试剂&耗材国产替代发展论坛', label: 'Life Science Instruments, reagents & Consumables Domestic Alternative Development Forum' },
        { id: '高端实验室仪器的现状发展与未来突破论坛', label: 'Status Quo Development and Future Breakthrough of high-end laboratory Instruments Forum' },
        { id: '生命科学仪器、试剂&耗材企业VC面对面', label: 'Life science instruments, reagents & Consumables enterprise VC face to face' },
        { id: '生命科学仪器、试剂&耗材企业新品发布会', label: 'Life science instruments, reagents & Consumables enterprise New product conference' },
      ]
    },
    {
      id: '经销采购', label: 'Distribution and Purchase',
      children: [
        { id: '医疗器械与药品经销商模式创新大会', label: 'Medical Device and Drug Distributor Model Innovation Conference' },
        { id: '民营医院采购大会', label: 'Private Hospital Procurement Conference' },
      ]
    },
    {
      id: '出海&海外BD', label: 'Going to Sea & Overseas BD',
      children: [
        { id: '中国创新医药医疗企业出海论坛', label: "China's Innovative Pharmaceutical and Medical Enterprises Going Overseas Forum" },
        { id: '医疗影像设备创新出海大会', label: 'Medical Imaging Equipment Innovation Conference' },
        { id: '体外诊断创新出海大会', label: 'In Vitro Diagnostic Innovation Sea Conference' },
        { id: '高值医疗耗材创新出海大会', label: 'High value medical consumables Innovation Sea Conference' },
        { id: '医美设备创新出海大会', label: 'Medical equipment Innovation Sea Conference' },
        { id: '医药领域（抗体药物、疫苗、创新大分子生物药、CGT、动物试验等出海大会', label: 'Pharmaceutical field (Antibody drugs, vaccines, innovative macromolecular biological drugs, CGT, animal testing, etc.) ' },
        { id: '中国创新医药医疗企业与MNC公司BD对接会', label: 'BD matchmaking meeting between Chinese innovative pharmaceutical and medical enterprises and MNC Company' },
      ]
    },
    {
      id: '生物制造产业', label: 'Bio-manufacturing industry',
      children: [
        {
          id: '生物制造产业创新合作论坛', label: 'Bio-manufacturing Industry Innovation Cooperation Forum',
          children: [
            { id: '农业与食品专场', label: 'Agriculture and Food Sessions' },
            { id: '医药与美妆专场', label: 'Medicine and Beauty Sessions' },
            { id: '医用及医美材料专场', label: 'Medical and Beauty Materials Special Session' },
          ]
        },
        { id: '高通量筛选与实验室自动化大会', label: 'High Throughput Screening and Laboratory Automation Conference' },
      ]
    },
    {
      id: '数字医疗', label: 'Digital Health',
      children: [
        { id: '药企数字化营销论坛', label: 'Pharmaceutical company Digital Marketing Forum' },
        { id: '医院智慧管理论坛', label: 'Hospital Smart Management Forum' },
        { id: '连锁诊所数智化论坛', label: 'Chain clinic number intelligent Forum' },
      ]
    },
    {
      id: '健康生活', label: 'Healthy living',
      children: [
        { id: '退休生活方式创新论坛', label: 'Retirement Lifestyle Innovation Forum' },
        { id: '减肥市场创新发展论坛', label: 'Weight Loss Market Innovation Development Forum' },
        { id: '抗衰创新论坛', label: 'Anti-aging Innovation Forum' },
      ]
    },
    { id: '未来医药医疗100强榜单', label: 'Top 100 List of Future Medicine and Healthcare' },
    { id: '创新产品力全球首发发布', label: 'Innovative product Force Global release' },
    { id: '医药医疗行业掼蛋大赛及社交活动', label: 'Medical Industry Whipped Contest and Social Events' },
    { id: 'VB100颁奖盛典暨大会交流晚宴', label: 'VB100 Award Ceremony and Conference Exchange Dinner' },
  ]
}



export default activityArr